import React, {useCallback, useRef} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {Filter} from '@ey/canvascoreservices';
import Search from '../../../../../../../components/Common/BaseComponentWrappers/MotifSearch';
import {labels} from '../../../../../../../util/utils';
import Utility from '../../../../../../../util/utilityfunctions';
import * as FilterActions from '../../../../../../../actions/SampleItemFilter/filteractions';

export const SampleItemFilter = (props) => {
	const {
		actions,
		filterConfiguration,
		state,
		dispatch,
		searchString,
		setSearchString
	} = props;
    const inputRef = useRef(searchString);

	const handleSetState = useCallback(
		(filters) => {
			dispatch({
				type: 'state/set',
				value: {
					filters
				}
			});
		},
		[dispatch]
	);

	const handleOnSetFilter = useCallback(
		(filter, value) => {
			actions.setFilters(filterConfiguration.key, filter, value);
		},
		[actions, filterConfiguration.key]
	);

    const handlerOnClearSearch = () => {
		setSearchString('');
		inputRef.current = '';
	};
	const onSearchChange = (e) => {
		inputRef.current = e.target.value.trimStart().slice(0, 100);
	};
	const onSearchEnter = () => {
		setSearchString(inputRef.current);
	};

	return (
		<StyledSampleItemFilters className="StyledSampleItemFilters">
			<Filter
				searchPlaceholder={labels.placeholderForSearch}
				filters={filterConfiguration}
				state={state.filters}
				onEnableFilter={handleOnSetFilter}
				onDisableFilter={handleOnSetFilter}
				labelYes={labels.filterYes}
				labelNo={labels.filterNo}
				noFiltersAvailableLabel={labels.sampleItemFilterLabels.noFiltersAvailable}
				noResultsPlaceholder={labels.noResultsAvavilable}
				tooltip={labels.sampleItemFilterLabels.filterToolTip}
				setState={handleSetState}
				theme={Utility.getTheme()}
			/>
			<StyledEYSearch
				styleName="sampleItem-search-input"
				key={'sampleItem-search'}
				value={searchString}
				placeholder={labels.searchPlaceholder}
				id={'search-sampleItem'}
				title={labels.searchPlaceholder}
				searchHoverText={labels.searchPlaceholder}
				onChange={onSearchChange}
				onSearchButtonClick={() => {
                    onSearchEnter();
                }}
				onClear={handlerOnClearSearch}
				onEnter={() => {
                    onSearchEnter();
                }}
				maxLength={100}
			/>
		</StyledSampleItemFilters>
	);
};

const mapState = (store) => {
	return {
		engagementId: store.engagement.engagementId
	};
};

const mapDispatch = (dispatch) => ({
	actions: {
		setFilter: (parentName, filterKey, filterItemName, value) =>
			dispatch(FilterActions.setFilter(parentName, filterKey, filterItemName, value)),
		setFilters: (filterKey, parentName, filters) => dispatch(FilterActions.setFilters(filterKey, parentName, filters))
	}
});

export default connect(mapState, mapDispatch)(SampleItemFilter);

const StyledEYSearch = styled(Search)``;
const StyledSampleItemFilters = styled.section`
	display: flex;
	.sampleItem-search-input {
		width: var(--px-400);
		margin: 0 0 0 var(--spacing-large);
		.motif-input {
			font-size: var(--px-14);
			&::placeholder {
				font-size: var(--px-14);
			}
		}
	}
`;
